export default __webpack_public_path__ + "static/media/public_pgp_key.c0e19939.asc";